import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryReceiptConfig(data) {
  return request({
    url: URL.sys.queryReceiptConfig,
    method: 'post',
    data
  })
}

export function saveReceiptConfig(data) {
  return request({
    url: URL.sys.saveReceiptConfig,
    method: 'post',
    data
  })
}

export function deleteReceiptConfig(data) {
  return request({
    url: URL.sys.deleteReceiptConfig,
    method: 'post',
    data
  })
}
